// extracted by css-extract-rspack-plugin
export default {"communicationSnapshotHeader":"communicationSnapshotHeader-rINv_a","widgetName":"widgetName-WVhgou","bottomBorder":"bottomBorder-Dw3v7c"};